module.exports = __webpack_public_path__ + "img/shoucangjia1.32ed354e.png";